/**
 * SAYM: 2 / 3 / 4 column switch for the product grid (desktop).
 * Stores the choice for the session on <html data-saym-columns>, which survives
 * Horizon's filter re-renders (the grid markup is morphed, <html> is not).
 */
const STORAGE_KEY = 'saym-grid-columns';

class SaymColumnToggle extends HTMLElement {
  connectedCallback() {
    let stored = null;
    try {
      stored = sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      // storage unavailable: keep the section default
    }
    this.#apply(stored || this.dataset.default, false);
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-columns]') : null;
    if (!(button instanceof HTMLElement)) return;
    this.#apply(button.dataset.columns, true);
  };

  /**
   * @param {string | undefined} columns
   * @param {boolean} persist
   */
  #apply(columns, persist) {
    if (!columns) return;
    document.documentElement.dataset.saymColumns = columns;
    this.querySelectorAll('[data-columns]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-columns') === columns));
    });
    if (!persist) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, columns);
    } catch (error) {
      // ignore
    }
  }
}

if (!customElements.get('saym-column-toggle')) {
  customElements.define('saym-column-toggle', SaymColumnToggle);
}
